import { useContext } from "react";
import DoctorsDirectory from "../00-Dashboard/DoctorsDirectory";
import { ScreenContext } from "../context/ScreenContext";
import TypesOfService from "../00-Dashboard/TypesOfService";
// import PreviousEntry from "../00-Dashboard/PreviousEntry";
import AreasAndServices from "../00-Dashboard/AreasAndServices";
import TypesOfValues from "../00-Dashboard/TypesOfValues";
import HomeServices from "../00-Dashboard/HomeServices";
// import SpecialPackages from "../00-Dashboard/SpecialPackages";
import FormOurServices from "../00-Dashboard/FormOurServices";
import FrequentlyQuestions from "../00-Dashboard/FrequentlyQuestions";
import Footer from "../components/Footer";
import InsuranceCompanies from "../components/InsuranceCompanies";
import { Helmet } from "react-helmet-async";

const Home = () => {
  /**
   * Valores extraídos del contexto `ScreenContext`, que proporcionan información sobre la pantalla.
   * `isMobile` es un valor booleano que indica si la vista actual corresponde a un dispositivo móvil.
   * `dimensionHeight` es la altura de la ventana del navegador.
   * @type {{isMobile: boolean, dimensionHeight: number}} Un objeto con las propiedades `isMobile` y `dimensionHeight`.
   */
  const { isMobile, dimensionWidth } = useContext(ScreenContext);
  return (
    <>
      <Helmet>
        {/* HTML */}
        <html lang="es-MX" />
        {/* Título */}
        <title>
          Centro Médico MEDAM | Hospital, urgencias y médicos especialistas en
          Texcoco
        </title>
        {/* Descripción */}
        <meta
          name="description"
          content="Centro Médico MEDAM en Texcoco: hospitalización, urgencias 24 horas, laboratorio clínico, torre médica, servicios a domicilio y médicos especialistas con atención profesional y humana."
        />
        {/* Keywords */}
        <meta
          name="keywords"
          content="Centro Médico MEDAM, hospital Texcoco, urgencias 24 horas, laboratorio clínico, médicos especialistas, torre médica, hospitalización, servicios médicos a domicilio, aseguradoras, consulta médica Texcoco"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Centro Médico MEDAM" />
        {/* Canonical */}
        <link rel="canonical" href="https://centromedicomedam.com/" />
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="es_MX" />
        <meta
          property="og:title"
          content="Centro Médico MEDAM | Hospital y médicos especialistas en Texcoco"
        />
        <meta
          property="og:description"
          content="Conoce nuestros servicios de urgencias, hospitalización, laboratorio clínico y atención médica especializada en Centro Médico MEDAM."
        />
        <meta property="og:url" content="https://centromedicomedam.com/" />
        <meta
          property="og:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png"
        />
        <meta property="og:site_name" content="Centro Médico MEDAM" />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Centro Médico MEDAM | Hospital y médicos especialistas en Texcoco"
        />
        <meta
          name="twitter:description"
          content="Urgencias 24 horas, hospitalización, laboratorio clínico y servicios médicos especializados en Texcoco."
        />
        <meta
          name="twitter:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png"
        />
        {/* Datos estructurados: organización médica */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Hospital",
              "name": "Centro Médico MEDAM",
              "url": "https://centromedicomedam.com",
              "logo": "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Color.png",
              "image": "https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png",
              "telephone": "5959570961",
              "streetAddress": "Centro Médico Medam, Calpulalpan-Texcoco 105, Xala, 56270 Texcoco de Mora, Méx.",
              "postalCode": "56270"
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Texcoco",
                "addressRegion": "Estado de México",
                "addressCountry": "MX"
              },
              "medicalSpecialty": [
                "Emergency",
                "Clinical laboratory",
                "Internal medicine",
                "General practice"
              ]
            }
          `}
        </script>
        {/* FAQ Schema */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "¿Cómo funciona el pre ingreso?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "El pre ingreso permite agilizar el proceso antes de tu llegada."
                  }
                },
                {
                  "@type": "Question",
                  "name": "¿Mi aseguradora tiene convenio?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Trabajamos con múltiples aseguradoras reconocidas a nivel nacional."
                  }
                },
                {
                  "@type": "Question",
                  "name": "¿Puedo agendar una cita con un doctor en específico?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Sí, puedes seleccionar el médico que prefieras desde nuestra web."
                  }
                },
                {
                  "@type": "Question",
                  "name": "¿Cómo funcionan los servicios a domicilio?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Nuestros profesionales acuden a tu domicilio previa programación."
                  }
                }
              ]
            }
          `}
        </script>
        {/* Breadcrumb */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Inicio",
                  "item": "https://centromedicomedam.com/"
                }
              ]
            }
          `}
        </script>
      </Helmet>
      <DoctorsDirectory isMobile={isMobile} />
      <TypesOfService />
      {/* <PreviousEntry isMobile={isMobile} /> */}
      <AreasAndServices isMobile={isMobile} dimensionWidth={dimensionWidth} />
      <TypesOfValues isMobile={isMobile} />
      <HomeServices isMobile={isMobile} />
      {/* <SpecialPackages isMobile={isMobile} dimensionWidth={dimensionWidth} /> */}
      <InsuranceCompanies />
      <FormOurServices />
      <FrequentlyQuestions />
      <Footer />
    </>
  );
};
export default Home;
